export default function pluralize(s: string, n: number, pluralSuffix = 's') {
  return n === 1 ? s : s + pluralSuffix;
}
